// extracted by mini-css-extract-plugin
var _1 = "styles-module__hoverClass___Ztoxi";
var _2 = "styles-module__socialIcons___A6F5A";
var _3 = "styles-module__title___zO9Hm";
export { _1 as "hoverClass", _2 as "socialIcons", _3 as "title" }
